






import mixins from '../../mixins';
import PChild from './p-child.vue';

type ChildComponent = InstanceType<typeof PChild>;

export default mixins().extend({
  props: {
    children: { type: Array, default: () => [] },
    tag: { type: String, default: 'div' },
    namespace: { type: String, default: 'default' },
  },
  data: () => ({
    allChildren: [] as any,
  }),
  methods: {
    updateValue() {
      // TODO: Unfortunately Vue has a bug when using v-model with this setup
      // input events from inputs inside slot are bubbled upwards breaking the setup
      // so for now just use the property children and sync modifier
      this.$emit('update:children', [...this.allChildren]);
    },
  },
  provide() {
    // Conserve 'this' context
    const self = this;
    return {
      register(child: ChildComponent): void {
        self.allChildren.push(child);
        self.updateValue();
        self.$emit('register', child);
      },

      unregister(child: ChildComponent): void {
        // eslint-disable-next-line no-underscore-dangle
        if ((self as any)._isDestroyed) {
          return;
        }
        const index = self.allChildren.indexOf(child);
        if (index >= 0) {
          self.allChildren.splice(index, 1);
          self.updateValue();
          self.$emit('unregister', child);
        }
      },
    };
  },
});

